import { css } from 'styled-components';

export const baseFont = css`
  font-family:
    'JakartaSans',
    -apple-system,
    Helvetica,
    Arial,
    sans-serif;
  font-style: normal;
  line-height: 124%;
  text-decoration: none;
  text-box-trim: trim-both;
`;

export const heading1 = css`
  ${baseFont};
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
`;

export const heading2 = css`
  ${baseFont};
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
`;

export const heading3 = css`
  ${baseFont};
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
`;

// Text Medium
export const textMediumNormal = css`
  ${baseFont};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`;

export const textMediumSemiBold = css`
  ${baseFont};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`;
export const textMediumBold = css`
  ${baseFont};
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
`;

// Text Small
export const textSmallNormal = css`
  ${baseFont};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
`;

export const textSmallSemiBold = css`
  ${baseFont};
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;
export const textSmallBold = css`
  ${baseFont};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
`;

// Text Tiny
export const textTinyLight = css`
  ${baseFont};
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
`;

export const textTinyNormal = css`
  ${baseFont};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const textTinySemiBold = css`
  ${baseFont};
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
`;
export const textTinyBold = css`
  ${baseFont};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
`;

// Text Extra Tiny
export const textExtraTinyNormal = css`
  ${baseFont};
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
`;
export const textExtraTinySemiBold = css`
  ${baseFont};
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
`;
export const textExtraTinyBold = css`
  ${baseFont};
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
`;

// this will not work in all browsers for now, but is a nice fallback
export const ellipsisExperimental = css`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-clamp: 1;
  overflow: hidden;
  line-height: 1.2rem;
  word-break: break-word;
`;
